import { userHasRight } from "../../../framework";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_TextArea from "../templates/K_TextArea";
import { ComponentOptions, RightLockable } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface TextAreaOptions extends ComponentOptions {
    required?: boolean | "true" | "false";
    cf?: boolean;
    hideSS?: boolean;
    textareaBsc?: string;
    bsc?: string;
    labelBsc?: string;
    valueWidth?: number | string;
    placeholder?: string;
    label?: string;
    hcLabel?: string;
    hcLabelAbove?: string;
    readonly?: boolean;
    requiredRight?: string;
    maxLength?: number | string;
}

export class TextArea extends TemplateComponent {

    options: TextAreaOptions & RightLockable;

    constructor(options: TextAreaOptions) {
        super(K_TextArea, options);
    }

    preRender() {
        const options = this.options;

        options.bindValue = buildDataBindSyntax(options.bindValue, "input");
        if (options.cf) {
            options.textareaBsc = options.textareaBsc || "col-xs-12 col-md-6 col-lg-4";
        }

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.readonly = true;
                options.containerClasses += " right-locked";
            }
        }
    }

    create() {
        var textArea = $("#" + this.id);
        var textAreaValue = "";

        textArea.on("change", function (e) {

            textAreaValue = textArea.val();

            if (textAreaValue.trim().length == 0) {
                textArea.val("");
            }

        });
    }

}
